import { Flex } from "@chakra-ui/react";
import InputSearch from "components/Input/InputSearch";
import ExportMenu from "components/ExportMenu";
import FiltrosHeaderTable from "ui/components/Page/ListingPageHeaderBar/components/FiltrosHeaderTable/index";

export interface HeaderTableProps {
  onSearch: (q?: string) => void;
  value: string;
  onExportPdf?: () => any;
  onExportExcel?: () => any;
  onFiltro?: () => void;
  badge?: number;
}

function HeaderTable({
  onSearch,
  value,
  onExportPdf,
  onExportExcel,
  onFiltro,
  badge,
}: HeaderTableProps) {
  return (
    <Flex flexDir="column">
      <Flex gridGap="16px" flexWrap="wrap" alignItems="center">
        <Flex w="100%" maxW="350px">
          <InputSearch defaultValue={value} onSearch={(v) => onSearch(v)} />
        </Flex>
        <Flex>
          <FiltrosHeaderTable
            badge={!!badge}
            badgeValue={badge}
            onFiltro={onFiltro!}
          />
        </Flex>

        <Flex flex={1} justifyContent="end">
          <Flex>
            <ExportMenu
              onExportPdf={onExportPdf}
              onExportarXlsx={onExportExcel}
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default HeaderTable;
